import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
const bullets = ['Why Eric Stoltz was fired after 6 weeks of filming', 'The 3 AM breakdown that almost killed the production', 'How a last-minute script change saved the entire film', "The exact moment Zemeckis knew they'd made history", 'The one casting decision that almost made the film unwatchable'];
export const ChillsSection = () => {
  return <section className="py-4 md:py-8 bg-gradient-to-b from-[#0d1117] to-bttf-bg relative overflow-hidden" data-id="element-102">
      <div className="absolute inset-0 bg-bttf-highlight/10 mix-blend-overlay" data-id="element-103"></div>
      <div className="container mx-auto px-4 relative z-10 max-w-3xl" data-id="element-104">
        <h2 className="text-3xl md:text-4xl font-bold font-future tracking-wide bg-gradient-main text-transparent bg-clip-text mb-3 pb-1 leading-tight text-center" data-id="element-105">
          If You Still Get Chills When The Lightning Hits...
        </h2>

        <p className="text-lg text-bttf-text font-body text-center mb-0.5" data-id="element-106">
          You're not nostalgic. You're a curator.
        </p>
        <p className="text-lg font-semibold text-bttf-primary font-body text-center mb-4" data-id="element-107">
          And this is the archive you've been waiting for.
        </p>

        <div className="mb-4" data-id="element-108">
          <p className="text-base font-semibold text-bttf-text font-body mb-3" data-id="element-109">
            Inside, you'll discover:
          </p>
          <ul className="space-y-2" data-id="element-110">
            {bullets.map((bullet, i) => <li key={i} className="flex items-start gap-3 text-bttf-subtext font-body text-sm md:text-base" data-id="element-111">
                <ArrowRightIcon className="h-4 w-4 text-bttf-primary flex-shrink-0 mt-0.5" data-id="element-112" />
                <span data-id="element-113">{bullet}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
};